import { io } from 'socket.io-client'
import threeCConfig from './ThreeCConfig'

class ThreeCSocketService {
  constructor () {
    this.socket = null
    this.connected = false
    this.socketId = null
    this.eventListeners = new Map()
  }

  async connect (token) {
    return new Promise((resolve, reject) => {
      if (this.connected) {
        resolve()
        return
      }

      this.socket = io(threeCConfig.SOCKET_URL, {
        ...threeCConfig.SOCKET_OPTIONS,
        query: { token },
        extraHeaders: {
          Authorization: `Bearer ${token}`,
          Origin: `${threeCConfig.API_BASE_URL}`
        }
      })

      const timeout = setTimeout(() => {
        reject(new Error('Timeout na conexão do socket'))
      }, threeCConfig.CONNECTION_TIMEOUT)

      this.socket.on('connect', () => {
        clearTimeout(timeout)
        this.connected = true
        this.socketId = this.socket.id
        resolve()
      })

      this.socket.on('connect_error', (error) => {
        clearTimeout(timeout)
        reject(error)
      })

      this.socket.on('disconnect', (reason) => {
        this.connected = false
        this.socketId = null
      })
    })
  }

  on (event, callback) {
    if (!this.socket) {
      console.warn('Socket não conectado. Evento não será registrado:', event)
      return
    }

    if (!this.eventListeners.has(event)) {
      this.eventListeners.set(event, [])
    }
    this.eventListeners.get(event).push(callback)

    this.socket.on(event, callback)
  }

  off (event, callback) {
    if (!this.socket) return

    if (callback) {
      this.socket.off(event, callback)
      const listeners = this.eventListeners.get(event)
      if (listeners) {
        const index = listeners.indexOf(callback)
        if (index > -1) {
          listeners.splice(index, 1)
        }
      }
    } else {
      this.socket.off(event)
      this.eventListeners.delete(event)
    }
  }

  once (event, callback) {
    if (!this.socket) {
      console.warn('Socket não conectado. Evento não será registrado:', event)
      return
    }

    this.socket.once(event, callback)
  }

  emit (event, data) {
    if (!this.socket) {
      console.warn('Socket não conectado. Evento não será emitido:', event)
      return
    }

    this.socket.emit(event, data)
  }

  disconnect () {
    if (this.socket) {
      this.socket.disconnect()
      this.connected = false
      this.socketId = null
      this.eventListeners.clear()
    }
  }

  isConnected () {
    return this.connected && this.socket.connected
  }

  getSocketId () {
    return this.socketId
  }

  removeAllListeners () {
    if (this.socket) {
      this.socket.removeAllListeners()
      this.eventListeners.clear()
    }
  }
}

export default new ThreeCSocketService()



// WEBPACK FOOTER //
// ./src/shared/services/voip/ThreeCSocketService.js